
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM8.13645 6.86361C7.78498 6.51214 7.21513 6.51214 6.86366 6.86361C6.51218 7.21508 6.51218 7.78493 6.86366 8.1364L10.7272 12L6.86358 15.8636C6.51211 16.2151 6.51211 16.7849 6.86358 17.1364C7.21505 17.4879 7.7849 17.4879 8.13638 17.1364L12 13.2728L15.8637 17.1364C16.2151 17.4879 16.785 17.4879 17.1364 17.1364C17.4879 16.7849 17.4879 16.2151 17.1364 15.8636L13.2728 12L17.1364 8.1364C17.4878 7.78493 17.4878 7.21508 17.1364 6.86361C16.7849 6.51214 16.215 6.51214 15.8636 6.86361L12 10.7272L8.13645 6.86361Z","fill":"#16171F"}})])
          )
        }
      }
    